// Estado de error (con botón de reintento)
export default function ErrorState({ message = 'Etwas ist schiefgelaufen.', onRetry }) {
  return (
    <div className="state-block state-error" role="alert">
      <div className="state-icon" aria-hidden="true">⚠️</div>
      <h2>Fehler beim Laden</h2>
      <p>{message}</p>
      {onRetry && (
        <button className="btn btn-primary" onClick={onRetry}>Erneut versuchen</button>
      )}
    </div>
  )
}
